import {
  arrayRemove,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore";

import { FIRESTORE_COLLECTIONS } from "@/lib/firebase/collections";
import { getFirestoreDb } from "@/lib/firebase/firestore-instance";
import { refreshFavoriteSongIds } from "@/lib/firebase/favorite-ids";
import { patchCachedFavoriteIds } from "@/lib/firebase/session-cache";

function nowIso(): string {
  return new Date().toISOString();
}

function normalizeSongId(songId: string): string {
  return songId.trim();
}

/** Mirrors mobile `UserDataService._addFavoriteToFirestore`. */
export async function addFavoriteSongId(
  uid: string,
  songId: string,
): Promise<void> {
  const id = normalizeSongId(songId);
  if (!id) {
    throw new Error("invalid_song_id");
  }

  const userRef = doc(getFirestoreDb(), FIRESTORE_COLLECTIONS.users, uid);
  const snap = await getDoc(userRef);

  if (snap.exists()) {
    await updateDoc(userRef, {
      favoriteSongIds: arrayUnion(id),
      updatedAt: nowIso(),
    });
  } else {
    await setDoc(userRef, {
      uid,
      favoriteSongIds: [id],
      updatedAt: nowIso(),
    });
  }

  patchCachedFavoriteIds(uid, (ids) =>
    ids.includes(id) ? ids : [...ids, id],
  );
  await refreshFavoriteSongIds(uid);
}

/** Mirrors mobile `UserDataService._removeFavoriteFromFirestore`. */
export async function removeFavoriteSongId(
  uid: string,
  songId: string,
): Promise<void> {
  const id = normalizeSongId(songId);
  if (!id) {
    return;
  }

  const userRef = doc(getFirestoreDb(), FIRESTORE_COLLECTIONS.users, uid);
  const snap = await getDoc(userRef);
  if (!snap.exists()) {
    return;
  }

  await updateDoc(userRef, {
    favoriteSongIds: arrayRemove(id),
    updatedAt: nowIso(),
  });

  patchCachedFavoriteIds(uid, (ids) => ids.filter((item) => item !== id));
  await refreshFavoriteSongIds(uid);
}
